/** @jsx jsx */
import React, { useState } from "react";
import { jsx, css } from "@emotion/core";
import { Formik, Field } from "formik";
import { Redirect } from "react-router";

import { post } from "../api";

import PrimaryCTAButton from "../../components/PrimaryCTA";
import Form from "../../components/Form";
import ValidationError from "../../components/ValidationError";
import RadioButton from "../../components/RadioButton";
import RadioGroup from "../../components/RadioGroup";

import { resourceUrls } from "../../config";
import { handlePost } from "../api/handler";
import PageContainer from "../components/PageContainer";

const initialValues = {
    healthDeclaration: null,
};

const submitHealthDeclaration = (
    setIsLoggedIn,
    setError,
    setFormSubmissionComplete
) => async (values, actions) => {
    const body = {
        healthDeclaration: values.healthDeclaration === "heath-declaration-yes",
        applicationStep: "HEALTH_DECLARATION",
    };

    await handlePost({
        postApiCall: () =>
            post({ url: resourceUrls.healthDeclaration.submit, body: body }),
        setIsLoggedIn: setIsLoggedIn,
        setError: setError,
        setIsSubmissionComplete: setFormSubmissionComplete,
    });

    actions.setSubmitting(false);
};

const HealthDeclaration = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [error, setError] = useState(null);
    const [formSubmissionComplete, setFormSubmissionComplete] = useState(false);

    if (formSubmissionComplete) {
        return (
            <Redirect
                push
                to={{
                    pathname: "/secure/apply",
                }}
            />
        );
    }

    return (
        <PageContainer error={error} isLoggedIn={isLoggedIn}>
            <h2
                css={css`
                    max-width: 90%;
                `}
            >
                Are you well enough to tutor?
            </h2>

            <p>
                Government regulations require you to be physically and mentally
                well enough to tutor on our platform. If you consider yourself
                healthy enough to tutor, please confirm this below.
            </p>
            <p>Please select an option:</p>

            <Formik
                initialValues={initialValues}
                onSubmit={submitHealthDeclaration(
                    setIsLoggedIn,
                    setError,
                    setFormSubmissionComplete
                )}
                render={({ isSubmitting, values, ...props }) => (
                    <Form onSubmit={props.handleSubmit}>
                        <RadioGroup>
                            <Field
                                name="healthDeclaration"
                                component={RadioButton}
                                id="heath-declaration-yes"
                                data-testid="heath-declaration-yes"
                                label="Yes - I’m well enough to tutor"
                            />
                            <Field
                                name="healthDeclaration"
                                component={RadioButton}
                                id="heath-declaration-no"
                                data-testid="heath-declaration-no"
                                label="No"
                            />
                        </RadioGroup>
                        <PrimaryCTAButton
                            type="submit"
                            data-testid="next-button"
                            disabled={
                                values.healthDeclaration === null ||
                                isSubmitting
                            }
                        >
                            Next →
                        </PrimaryCTAButton>
                    </Form>
                )}
            />
        </PageContainer>
    );
};

export default HealthDeclaration;
